import ExploreNft from './ExploreNft';
import './styles.css';

const Explore2PageBody = () => {
  return (
    <>
      {/* <Grid
        style={{
          width: '20%',
          marginTop: '150px',
          display: 'flex',
          paddingLeft: '10px',
          paddingRight: '10px',
          marginLeft: '600px',
        }}
      >
        <Button
          onClick={() => {
            navigate('/explore/nft');
          }}
          type="submit"
          style={{
            color: 'black',
            textDecoration: 'none',
            borderRadius: '15px',
            width: '50%',
            fontSize: '13px',
            textTransform: 'none',
            backgroundColor: '#ddb930',
            fontWeight: 'bold',
            padding: '10px',
            alignSelf: 'center',
            boxShadow: 'none',
          }}
        >
          Explore NFT
        </Button>
        <Button
          onClick={() => {
            navigate('/explore/otr');
          }}
          type="submit"
          style={{
            color: 'black',
            textDecoration: 'none',
            borderRadius: '15px',
            width: '50%',
            fontSize: '13px',
            textTransform: 'none',
            backgroundColor: '#ddb930',
            fontWeight: 'bold',
            padding: '10px',
            alignSelf: 'center',
            boxShadow: 'none',
          }}
        >
          Explore OTR
        </Button>
      </Grid> */}

      <ExploreNft />
    </>
  );
};

export default Explore2PageBody;
